module.exports = __webpack_public_path__ + "fonts/icons.f3a7a45.woff2";